export const all = (...args) => context => args.reduce((final, f) => final && f.apply(null, [context]), true);
export const one = (...args) => context => args.reduce((final, f) => final || f.apply(null, [context]), false);
export const not = (f) => context => !f.apply(null, [context]);